import React, { useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import ModalDialog from '@atlaskit/modal-dialog';
import ExitingPersistence from '@atlaskit/motion/exiting-persistence';
import ShortcutScope from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcut-scope.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	SCREEN,
	ContextualAnalyticsData,
	FireScreenAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { MODAL_STATE_IN_PROGRESS, MODAL_STATE_SUCCESS, MODAL_STATE_FAIL } from '../types';
import FailureStatusModal from './failure-status/main.tsx';
import InProgressStatusModal from './in-progress-status/main.tsx';
import SuccessStatusModal from './success-status/main.tsx';
import type { Props } from './types';

const ModalByStatus = ({
	setModalShown,
	setShouldRefetch,
	appName,
	modalState,
	configurationUrl,
	analyticsAttributes,
	onTryAgain,
	isBlanketHidden,
	// note: contact #makkuro-team if planning to use this prop
	onDismissSuccessModal,
}: Props) => {
	const handleCloseModal = useCallback(() => {
		setModalShown(false);
		if (
			modalState === MODAL_STATE_SUCCESS &&
			onDismissSuccessModal &&
			fg('jira_improve_scm_onboarding_gate')
		) {
			onDismissSuccessModal();
		}
	}, [setModalShown, modalState, onDismissSuccessModal]);

	return (
		<ContextualAnalyticsData
			sourceName="modalByStatus"
			sourceType={SCREEN}
			attributes={{ ...analyticsAttributes, appName, status: modalState }}
		>
			<FireScreenAnalytics />
			<ShortcutScope>
				<ExitingPersistence exitThenEnter>
					<ModalDialog
						width="large"
						autoFocus={false}
						isBlanketHidden={isBlanketHidden}
						onClose={handleCloseModal}
					>
						{modalState === MODAL_STATE_IN_PROGRESS && <InProgressStatusModal appName={appName} />}
						{modalState === MODAL_STATE_SUCCESS && (
							<SuccessStatusModal
								setShouldRefetch={setShouldRefetch}
								appName={appName}
								configurationUrl={configurationUrl}
								analyticsAttributes={analyticsAttributes}
								onConfigure={handleCloseModal}
								onMaybeLater={handleCloseModal}
							/>
						)}
						{modalState === MODAL_STATE_FAIL && (
							<FailureStatusModal
								analyticsAttributes={analyticsAttributes}
								onTryAgain={onTryAgain}
								onCancel={handleCloseModal}
							/>
						)}
					</ModalDialog>
				</ExitingPersistence>
			</ShortcutScope>
		</ContextualAnalyticsData>
	);
};

export default ModalByStatus;
